import React, { useState } from 'react';
import { TextField, Button, ButtonGroup, Container, Box, Typography } from '@mui/material';

interface Props {
  name?: string;
  value?: string;
  label?: string; // Add the missing prop helperText
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onError?: string;
  error?: boolean;
  helperText?: string;
  variant?: 'standard' | 'outlined';
  margin?: 'normal' | 'dense';
  fullWidth?: boolean;
}

const TextFieldNumpad: React.FC<Props> = (props: Props) => {
  const { name, label, onError, helperText, variant, margin, fullWidth } = props
  const [value, setValue] = useState<string>('');
  
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow numeric characters (0-9) and filter out others
    const newValue = event.target.value.replace(/[^0-9]/g, '');
    setValue(newValue);

    // Call the onChange prop if provided
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const handleNumpadClick = (num: number | string) => {
    // Handle numpad button clicks
    let newValue: string;

    if (num === '✖') {
      newValue = '';
    } else if (num === '⌫') {
      newValue = value.slice(0, -1);
    } else {
      newValue = value + num.toString();
    }

    setValue(newValue);

    // Call the onChange prop if provided
    if (props.onChange) {
      props.onChange({ target: { value: newValue } } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  // Numpad layout
  const numpadButtons = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    ['✖', 0, '⌫'],
  ];

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6" sx={{ color: '#ffd54f' }}>{ name || 'Numeric Input' }</Typography>
        
        {/* MUI TextField configured for numeric input */}
        <TextField
          label={label}
          variant={variant || 'standard'}
          fullWidth
          value={value}
          onChange={handleInputChange}
          // The inputMode hint helps mobile devices display the correct numpad keyboard
          InputProps={{
            inputMode: 'numeric', 
          }}
        />

        {/* Custom Numpad Button Group */}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
          {numpadButtons.map((row, rowIndex) =>
            row.map((buttonValue) => (
              <Button
                key={buttonValue}
                variant="contained"
                onClick={() => handleNumpadClick(buttonValue)}
                sx={{ fontSize: '2rem', width: '120px', mmargin: 1 }}
              >
                {buttonValue}
              </Button>
            ))
          )}
        </Box>

      </Box>
    </Container>
  );
};

export default TextFieldNumpad;
